import { useMediaQuery } from '@sequencehq/utils'

/**
 * True below Chakra's `md` breakpoint (48em / 768px) — i.e. on phone-sized
 * viewports. It is the exact complement of an `md` style prop, so a component
 * can mix this hook with `{ base, md }` props without the two disagreeing.
 */
export const useIsMobile = (): boolean => {
  const [isDesktop] = useMediaQuery('(min-width: 48em)')

  return !isDesktop
}
